export default {
    namespaced: true,
    state: {
        display: true,
        options: {}
    },
    getters: {
        display: state => state.display,
        options: state => state.options
    },
    mutations: {
        setDisplay: (state, display) => state.display = display,
        setOptions: (state, options) => state.options = options,
        clearOptions: state => state.options = {}
    },
    actions: {
        setDisplay: (context, display) => context.commit("setDisplay", display),
        setOptions: (context, options) => context.commit("setOptions", options),
        clearOptions: (context) => context.commit("clearOptions"),
    }
}